module.exports = require("./haw-US");